(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
const initContactSelects=scope=>{
  scope.querySelectorAll('[data-m-select]').forEach(select=>{
    if(select.dataset.ready)return
    select.dataset.ready='true'
    const input=select.querySelector('.m-select__input')
    const toggle=select.querySelector('.m-select__toggle')
    const menu=select.querySelector('.m-select__menu')
    const options=[...select.querySelectorAll('.m-select__option')]
    let active=-1
    let restoringFocus=false
    const visible=()=>options.filter(option=>!option.hidden)
    const open=()=>{
      menu.hidden=false
      select.classList.add('is-open')
      input.setAttribute('aria-expanded','true')
    }
    const close=()=>{
      menu.hidden=true
      select.classList.remove('is-open')
      input.setAttribute('aria-expanded','false')
      active=-1
    }
    const choose=option=>{
      input.value=option.textContent.trim()
      options.forEach(item=>item.setAttribute('aria-selected',String(item===option)))
      input.dispatchEvent(new Event('change',{bubbles:true}))
      close()
      restoringFocus=true
      input.focus()
      queueMicrotask(()=>{restoringFocus=false})
    }
    const focusOption=index=>{
      const items=visible()
      if(!items.length)return
      active=(index+items.length)%items.length
      items[active].focus()
    }
    input.addEventListener('focus',()=>{
      if(restoringFocus)return
      options.forEach(option=>{option.hidden=false})
      open()
    })
    input.addEventListener('click',open)
    input.addEventListener('input',()=>{
      const term=input.value.trim().toLocaleLowerCase()
      options.forEach(option=>{option.hidden=term!==''&&!option.textContent.toLocaleLowerCase().includes(term)})
      open()
    })
    input.addEventListener('keydown',event=>{
      if(event.key==='ArrowDown'){event.preventDefault();open();focusOption(0)}
      if(event.key==='Escape')close()
    })
    toggle.addEventListener('click',()=>menu.hidden?open():close())
    options.forEach(option=>{
      option.addEventListener('click',()=>choose(option))
      option.addEventListener('keydown',event=>{
        const items=visible()
        const index=items.indexOf(option)
        if(event.key==='ArrowDown'){event.preventDefault();focusOption(index+1)}
        if(event.key==='ArrowUp'){event.preventDefault();focusOption(index-1)}
        if(event.key==='Enter'||event.key===' '){event.preventDefault();choose(option)}
        if(event.key==='Escape'){close();input.focus()}
      })
    })
    document.addEventListener('click',event=>{if(!select.contains(event.target))close()})
  })
}
initContactSelects(document)
document.addEventListener('shopify:section:load',event=>initContactSelects(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-policy-minguez"] && !Shopify.designMode) return;
  try {
    
  const declarationMount = document.querySelector('[data-cookie-declaration]');

  if (declarationMount && !document.getElementById('CookieDeclaration')) {
    const declarationScript = document.createElement('script');
    declarationScript.id = 'CookieDeclaration';
    declarationScript.src = 'https://consent.cookiebot.com/06ea95a2-c126-4b91-9727-c9ae884a7ba5/cd.js';
    declarationScript.type = 'text/javascript';
    declarationScript.dataset.culture = 'ES';
    declarationScript.async = true;
    declarationMount.appendChild(declarationScript);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cookie-settings]');
    if (!button) return;

    if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
      window.Cookiebot.renew();
      return;
    }

    if (window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
      window.CookieConsent.renew();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
  super();
  }

  connectedCallback() {
  this.header = document.querySelector('.section-header');
  this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
  this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  this.headerBounds = {};

  this.setHeaderHeight();

  window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

  if (this.headerIsAlwaysSticky) {
  this.header.classList.add('shopify-section-header-sticky');
  };

  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');

  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);

  this.createObserver();
  }

  setHeaderHeight() {
  document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
  let observer = new IntersectionObserver((entries, observer) => {
  this.headerBounds = entries[0].intersectionRect;
  observer.disconnect();
  });

  observer.observe(this.header);
  }

  onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (this.preventHide) return;
  requestAnimationFrame(this.hide.bind(this));
  } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) {
  this.header.classList.remove('scrolled-past-header');
  requestAnimationFrame(this.reset.bind(this));
  }

  this.currentScrollTop = scrollTop;
  }

  hide() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  this.closeMenuDisclosure();
  this.closeSearchModal();
  }

  reveal() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.add('shopify-section-header-sticky', 'animate');
  this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
  if (this.headerIsAlwaysSticky) return;
  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  this.searchModal.close(false);
  }
  }

  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minguez-commerce-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mh-search-tabs').forEach((tabs) => {
    const home = tabs.closest('.mh-home');
    const input = home.querySelector('.mh-hero-search input[type="search"]');
    tabs.querySelectorAll('[role="tab"]').forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.querySelectorAll('[role="tab"]').forEach((item) => item.setAttribute('aria-selected', 'false'));
        tab.setAttribute('aria-selected', 'true');
        input.placeholder = tab.dataset.placeholder;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sole-marine-engines"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sole-engines').forEach((section) => {
    const modelSelect = section.querySelector('[data-sole-model-select]');
    section.querySelectorAll('[data-sole-model]').forEach((button) => {
      button.addEventListener('click', () => {
        if (modelSelect) modelSelect.value = button.dataset.soleModel;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
